module.exports = __webpack_public_path__ + "img/gb-icon.be5daf55.png";